import { LineChart, FolderLock, FileText, Presentation } from "lucide-react";

const SERVICES = [
  {
    icon: LineChart,
    title: "Financial Modeling",
    body: "Five-year, VC-grade projections with unit economics, sensitivities and scenario planning that investors actually trust.",
    span: "md:col-span-7",
  },
  {
    icon: FolderLock,
    title: "Investor Data Rooms",
    body: "End-to-end data room build — cap table, financials, legal, traction. Audit-ready, share-ready.",
    span: "md:col-span-5",
  },
  {
    icon: FileText,
    title: "Grant Application Writing",
    body: "Tailored applications for Tony Elumelu, Mastercard Foundation, World Bank, USAID, EU and corporate grants.",
    span: "md:col-span-5",
  },
  {
    icon: Presentation,
    title: "Pitch Decks That Close",
    body: "Narrative + numbers that win meetings and close rounds. Built for African context, told to a global audience.",
    span: "md:col-span-7",
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta">What we do</p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-umber sm:text-5xl">
            The full toolkit to make your business{" "}
            <span className="italic text-terracotta">fundable</span>.
          </h2>
          <p className="mt-5 text-lg text-umber/70">
            Whether you&apos;re applying for your first grant or raising a Series A — we build the documents international
            funders expect, on their standards.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-border bg-sand/50 p-8 transition hover:-translate-y-1 hover:shadow-xl ${s.span}`}
            >
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-md bg-umber text-cream group-hover:bg-terracotta">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-2xl font-semibold text-umber">{s.title}</h3>
              <p className="mt-3 max-w-lg text-umber/70">{s.body}</p>
              <div className="pointer-events-none absolute -right-10 -bottom-10 h-40 w-40 rounded-full bg-gold/10 blur-3xl" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
